<script lang="ts" setup>
  const props = withDefaults(defineProps<{
    icon?: string;
    size?: number;
    rounded?: boolean;
  }>(), {
    icon: 'home',
    size: 22,
    rounded: true,
  });

  const styles = {
    fontSize: `${props.size}px`,
  };
</script>

<template>
  <span
      :class="{
        'icon': true,
        'material-symbols-outlined': props.rounded
      }"
      :style="styles"
  >
    {{ props.icon }}
  </span>
</template>

<style lang="scss" scoped>
  .icon {
    vertical-align: bottom;
  }
</style>
